import axios from 'axios';
import { getRuntimeEnv } from './runtimeEnv';

const API_BASE = getRuntimeEnv('REACT_APP_BACKEND_URL', '');

const api = axios.create({
  baseURL: `${API_BASE}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('gymify_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

const clearSessionAndRedirect = () => {
  localStorage.removeItem('gymify_token');
  localStorage.removeItem('gymify_user');
  localStorage.removeItem('gymify_refresh');
  window.location.href = '/login';
};

// Cognito mode hands out short-lived ID tokens plus a refresh token; on the
// first 401 we try one silent renewal (bare axios — not `api` — so a failing
// refresh can't recurse), then retry the original request. Without a refresh
// token (local auth) a 401 logs out immediately, as before.
let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    const refreshToken = localStorage.getItem('gymify_refresh');
    if (error.response?.status === 401 && refreshToken && !original._retried) {
      original._retried = true;
      try {
        if (!refreshPromise) {
          const email = JSON.parse(localStorage.getItem('gymify_user') || '{}').email;
          refreshPromise = axios.post(`${API_BASE}/api/v1/auth/refresh`, {
            refresh_token: refreshToken,
            email,
          });
        }
        const { data } = await refreshPromise;
        refreshPromise = null;
        localStorage.setItem('gymify_token', data.access_token);
        localStorage.setItem('gymify_user', JSON.stringify(data.user));
        if (data.refresh_token) localStorage.setItem('gymify_refresh', data.refresh_token);
        original.headers = { ...original.headers, Authorization: `Bearer ${data.access_token}` };
        return api(original);
      } catch {
        refreshPromise = null;
        clearSessionAndRedirect();
        return Promise.reject(error);
      }
    }
    if (error.response?.status === 401) {
      clearSessionAndRedirect();
    }
    return Promise.reject(error);
  }
);

export default api;
